var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-submenu"},[_c('div',{staticClass:"navbar-submenu__title strong"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"navbar-submenu__options-wrapper"},_vm._l((this.menuOptions),function(option){return _c('a',{key:option.id,class:[
        'navbar-submenu__option',
        'align-items-center flex-row d-flex',
      ],attrs:{"href":_vm.optionUrl(option)}},[_c('TextEllipsis',{attrs:{"text":option.label,"font-size":"14px","width":"100%"}}),(_vm.focusedOption === option.value)?_c('font-awesome-icon',{attrs:{"icon":"check"}}):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }